import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from './services/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'intelous';
  private subscription = new Subscription();

  constructor(private router: Router,
    private commonService: CommonService) {
    commonService.serRandomTrackingId();
  }

  ngOnInit() {
    this.subscription.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(event => {
          localStorage.removeItem('ignoreLayout');
        })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
